import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URI } from 'src/shared/constants';
import { EngagementDTO } from '@/interfaces/engagementDTO.interface';

@Injectable({ providedIn: 'root' })
export class EngagementService {
  constructor(private http: HttpClient) {}

  getAllDTO(): Observable<EngagementDTO[]> {
    const url = API_BASE_URI + '/api/engagement';

    return this.http.get<EngagementDTO[]>(url);
  }

  findByJobCode(jobCode: string): Observable<EngagementDTO> {
    const url =
      API_BASE_URI + `/api/engagement/GetByJobCode?jobCode=${jobCode}`;

    return this.http.get<EngagementDTO>(url);
  }
}
